// ==================== ORGANIZATION OPTIONS ====================
// Multiple organizations: the options of the header's Account dropdown.

import type { SelectOption } from '../ui';
import type { Organization } from '../../services/organizations.service';

/** Value of the dropdown's "All Accounts" option */
export const ALL_ORGANIZATIONS = 'all';

/** Account dropdown: all accounts, then each one */
export const organizationFilterOptions = (organizations: Organization[]): SelectOption[] => [
  { value: ALL_ORGANIZATIONS, label: 'All Accounts' },
  ...organizations.map((organization) => ({
    value: organization.id,
    label: organization.businessName,
  })),
];
